import { Box } from "../Box"
import { Flex } from "../Flex"
import { Text } from "../Typography"
import { GaugeComponent, GaugeProps } from "./GaugeComponent"
import { Needle } from "./Needle"
import * as styles from "./styles"

export type Props<TData, TLabel> = {
  chart: GaugeProps<TData, TLabel>
  value: number | null
  min: number
  max: number
  dataTestIds?: {
    component?: string
    maxLabel?: string
    minLabel?: string
  }
}

export const GAUGE_TEST_IDS = {
  GAUGE_COMPONENT: `gauge-component`,
  GAUGE_MIN_LABEL: `gauge-min-label`,
  GAUGE_MAX_LABEL: `gauge-max-label`,
}

export const Gauge = <TData = number, TLabel = unknown>({
  chart,
  value,
  min,
  max,
  dataTestIds,
}: Props<TData, TLabel>) => (
  <Flex justifyContent="center" alignItems="center" data-testid={dataTestIds?.component}>
    <Box css={styles.root}>
      <GaugeComponent {...chart} />
      <Text css={styles.rangeStart} data-testid={dataTestIds?.minLabel}>
        {min}
      </Text>
      <Text css={styles.rangeEnd} data-testid={dataTestIds?.maxLabel}>
        {max}
      </Text>
      {value != null && <Needle value={value} max={max} />}
    </Box>
  </Flex>
)

Gauge.defaultProps = {
  dataTestIds: undefined,
}
